
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-e69cf906!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/htmlhint-loader/index.js??ref--0!./Materials.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/htmlhint-loader/index.js??ref--0!./Materials.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-e69cf906!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/htmlhint-loader/index.js??ref--0!./Materials.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/share/Materials.vue
// module id = 631
// module chunks = 1